<div class="col-md-12 pb-2 ziro-datatable-content">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs></ziro-breadcrumbs>
    <ziro-datatable
      [class]="'ziro-card'"
      [dataAutomation]="tableDataAutomation"
      [columns]="columns"
      [rowDataSource]="data"
      [uniqueRowIdentifier]="null"
      [showCustomAlert]="true"
      [setColumnWidths]="false"
    >
      <div alert-content [innerHtml]="'tkey;admin.site_management.site.no_results' | escapeHtml"></div>
    </ziro-datatable>
  }
</div>
